import ContentPageLayout from 'components/ContentPageLayout'

const Terms = (): JSX.Element => {
	return <ContentPageLayout contentKey="terms" />
}

export default Terms
